'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleIconStyled = undefined;

var _templateObject = _taggedTemplateLiteral(['\n        ', '\n      '], ['\n        ', '\n      ']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleIcons = require('reactackle-icons');

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var propTypes = {
  expanded: _propTypes2.default.bool,
  autoCollapsing: _propTypes2.default.bool
};

var defaultProps = {
  expanded: false,
  autoCollapsing: false
};

/** Prop Receivers */
var iconSize = function iconSize(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.sidebar.toggleButton.icon,
      width = _theme$reactackle$com.width,
      height = _theme$reactackle$com.height,
      imgSize = _theme$reactackle$com.imgSize;


  return (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(height), (0, _reactackleCore.getValueString)(imgSize || height), (0, _reactackleCore.getValueString)(width || height)));
};

var state = function state(_ref2) {
  var themeFromProvider = _ref2.theme,
      expanded = _ref2.expanded,
      autoCollapsing = _ref2.autoCollapsing;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var iconPath = theme.reactackle.components.sidebar.toggleButton.icon.style,
      widthChangingBreakpoint = theme.reactackle.components.sidebar.sidebar.widthChangingBreakpoint;


  var collapsedStyles = '\n    width: ' + (0, _reactackleCore.getValueString)(iconPath.collapsed.width) + ';\n    margin-left: ' + (0, _reactackleCore.getValueString)(iconPath.collapsed.marginLeft) + ';\n    opacity: ' + iconPath.collapsed.opacity + ';\n    transform: rotate(180deg);\n    ' + (0, _reactackleIcons.iconStyleMixin)(iconPath.collapsed.color) + '\n    \n    &:hover {\n      color: ' + iconPath.collapsed.hover.color + ';\n      opacity: ' + iconPath.collapsed.hover.opacity + ';\n    }\n    \n    &:focus {\n      color: ' + iconPath.collapsed.focus.color + ';\n      opacity: ' + iconPath.collapsed.focus.opacity + ';\n    }\n  ';

  var expandedStyles = '\n    width: ' + (0, _reactackleCore.getValueString)(iconPath.expanded.width) + ';\n    margin-left: ' + (0, _reactackleCore.getValueString)(iconPath.expanded.marginLeft) + ';\n    opacity: ' + iconPath.expanded.opacity + ';\n    ' + (0, _reactackleIcons.iconStyleMixin)(iconPath.expanded.color) + '\n    \n    &:hover {\n      color: ' + iconPath.expanded.hover.color + ';\n      opacity: ' + iconPath.expanded.hover.opacity + ';\n    }\n    \n    &:focus {\n      color: ' + iconPath.expanded.focus.color + ';\n      opacity: ' + iconPath.expanded.focus.opacity + ';\n    }\n  ';

  if (autoCollapsing) {
    return (0, _styledComponents.css)(['', ' ', ''], expanded ? expandedStyles : collapsedStyles, (0, _reactackleCore.media)(widthChangingBreakpoint)(_templateObject, !expanded ? collapsedStyles : expandedStyles));
  } else {
    return (0, _styledComponents.css)(['', ''], !expanded ? collapsedStyles : expandedStyles);
  }
};

/** Styles */
var ToggleIconStyled = exports.ToggleIconStyled = _styledComponents2.default.div.withConfig({
  displayName: 'ToggleIconStyled'
})(['display:flex;position:relative;flex-shrink:0;justify-content:center;', ' ', ' ', ';'], iconSize, state, (0, _reactackleCore.transition)('transform, width, margin'));

ToggleIconStyled.propTypes = propTypes;
ToggleIconStyled.defaultProps = defaultProps;
ToggleIconStyled.displayName = 'ToggleIconStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-sidebar/dist/SidebarToggle/styles/ToggleIconStyled.js
// module id = 805
// module chunks = 0